<template>
  <v-container class="col-12 entity-report-container">
    <v-card class="pa-4">
      <v-row class="mx-0" style="white-space: nowrap">
        <v-text-field
          label="Search"
          v-model="search"
          class="col-3"
          :autocomplete="false"
          hide-details
        />


        <date-picker
          v-model="date"
          label="Report by Date"
          style="max-width: 160px"
        />

        <v-btn
          color="info"
          class="mt-3 ml-3"
          :loading="loading"
          :disabled="loading"
          @click="loadEntities()"
        >
          Search
        </v-btn>
      </v-row>
      <small class="ml-3" style="color: rgba(0, 0, 0, 0.6)">Data collects once per day, for actual information use another reports</small>
    </v-card>


    <v-card class="col-12 pa-0 mt-5">
      <v-card-text class="col-12 pa-0" :style="`height: calc(100vh - 170px); overflow: auto;`">

        <v-progress-linear
          indeterminate
          color="green"
          v-if="loading"
        ></v-progress-linear>

        <vue-ads-table
          :columns="columns"
          :rows="treeData"
          :filter="filterStr"
          :classes="classes"
          @filter-change="filterChanged"
        >

          <template slot="ngr" slot-scope="props">
            <span class="text-no-wrap">{{ get(props, `row.report.totalByProject.${keys.mtd}.ngr`, 0) }} <template v-if="props.row._children.length > 0"> / T: {{ get(props, `row.report.total.${keys.mtd}.ngr`, 0) }}</template></span>
          </template>
          <template slot="ggr" slot-scope="props">
            <span class="text-no-wrap">{{ get(props, `row.report.totalByProject.${keys.mtd}.ggr`, 0) }} <template v-if="props.row._children.length > 0"> / T: {{ get(props, `row.report.total.${keys.mtd}.ggr`, 0) }}</template></span>
          </template>
          <template slot="deposit" slot-scope="props">
            <span class="text-no-wrap">{{ get(props, `row.report.totalByProject.${keys.mtd}.deposit`, 0) }} <template v-if="props.row._children.length > 0"> / T: {{ get(props, `row.report.total.${keys.mtd}.deposit`, 0) }}</template></span>
          </template>
          <template slot="withdraw" slot-scope="props">
            <span class="text-no-wrap">{{ get(props, `row.report.totalByProject.${keys.mtd}.withdraw`, 0) }} <template v-if="props.row._children.length > 0"> / T: {{ get(props, `row.report.total.${keys.mtd}.withdraw`, 0) }}</template></span>
          </template>
          <template slot="registrations" slot-scope="props">
            <span class="text-no-wrap">{{ get(props, `row.report.totalByProject.${keys.mtd}.registrations.total`, 0) }} <template v-if="props.row._children.length > 0"> / T: {{ get(props, `row.report.total.${keys.mtd}.registrations`, 0) }}</template></span>
          </template>
          <template slot="funded" slot-scope="props">
            <span class="text-no-wrap">{{ get(props, `row.report.totalByProject.${keys.mtd}.funded`, 0) }} <template v-if="props.row._children.length > 0"> / T: {{ get(props, `row.report.total.${keys.mtd}.funded`, 0) }}</template></span>
          </template>

          <template slot="toggle-children-icon" slot-scope="props">
            <v-icon>{{ props.expanded ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
          </template>
        </vue-ads-table>

      </v-card-text>
    </v-card>
  </v-container>
</template>

<style>

  .entity-control_card .rotate {
    -moz-transition: all 0.2s linear;
    -webkit-transition: all 0.2s linear;
    transition: all 0.2s linear;
  }

  .entity-control_card .rotate.down {
    -ms-transform: rotate(-180deg);
    -moz-transform: rotate(-180deg);
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }

  .kiosk-action-cell {
    width: 50px;
  }

  .kiosk-inner-border {
    padding: 0px;
    white-space: nowrap;
  }

  .kiosk-inner-border > span {
    padding: 8px 5px;
    border-left: 1px dashed #EEE;
    white-space: nowrap;
  }

  .kiosk-balances span:not(:last-child) {
    border-right: 1px solid #CCC;
  }

  .entity-report-container .vue-ads-py-4 {
    padding-top: 4px;
    padding-bottom: 4px;
  }

</style>

<script>
  import { API } from '@/utils/api'
  import { debounce, remove, map, get } from 'lodash'
  import moment from 'moment'

  import 'vue-ads-table-tree/dist/vue-ads-table-tree.css'
  import { VueAdsTable } from 'vue-ads-table-tree'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    props: { title: {}, headers: {}, projectList: { default: () => ([]) }, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      VueAdsTable,
      DatePicker
    },

    data: () => ({
      date: moment().format('YYYY-MM-DD'),
      data: [],
      keys: {},
      treeData: [],
      initData: [],

      infoDialog: false,
      loading: false,

      currencies: [],

      expandedMap: {},

      search: '',
      filterStr: '',
      classes: {
        table: {
          'vue-ads-border': true,
          'vue-ads-w-full': true
        },
        'all/': {
          'vue-ads-border-b': true
        },
        'all/-2_': {
          'kiosk-action-cell': true
        },
        '0/all': {
          'vue-ads-px-4': true,
          'vue-ads-py-2': true,
          'vue-ads-border-r': true,
        },
        '1_/all': {
          'vue-ads-px-4': true,
          'vue-ads-py-4': true,
          'vue-ads-border-r': true,
        },
        '1_/0': {
          'vue-ads-py-1': false,
          'kiosk-inner-border': true,
        },
        'even/': {
          'hover:vue-ads-bg-gray-200': true,
          'vue-ads-bg-gray-100': true,
          'vue-ads-border-b': true,
        },
        '0/': {
          'vue-ads-cursor-pointer': true,
          'vue-ads-border-r': true,
          'vue-ads-text-sm': true,
          'vue-ads-text-left': true,
        }
      },
      columns: [
        {
          property: 'name',
          title: 'Project',
          direction: null,
          filterable: true,
          collapseIcon: true,
        },
        {
          property: 'entity_id',
          title: 'EntityID',
          direction: null,
          filterable: true,
        },
        {
          property: 'registrations',
          title: 'Registrations',
          direction: null,
          filterable: false,
        },
        {
          property: 'funded',
          title: 'FTD',
          direction: null,
          filterable: false,
        },
        {
          property: 'deposit',
          title: 'Deposits',
          direction: null,
          filterable: false,
        },
        {
          property: 'withdraw',
          title: 'Withdraw',
          direction: null,
          filterable: false,
        },
        // {
        //   property: 'ggr',
        //   title: 'GGR',
        //   direction: null,
        //   filterable: false,
        // },
        // {
        //   property: 'ngr',
        //   title: 'NGR',
        //   direction: null,
        //   filterable: false,
        // },
      ],
    }),

    mounted () {
      this.loadEntities()
    },

    computed: {},

    watch: {
      search: debounce(function () {
        this.filterStr = this.search
      }, 500)
    },

    methods: {

      get,

      cl (d) {
        console.log(d)
      },

      filterChanged (filter) {
        this.filter = filter
      },

      loadEntities () {
        this.loading = true

        this.expandedMap = {}
        this.getExpanded(this.treeData)

        return API.call(this.url, { expanded: this.expandedMap, date: this.date }).then(resp => {

          this.keys = resp.keys
          this.treeData = resp.data
          this.currencies = resp.data[0] && resp.data[0].wallet ? map(resp.data[0].wallet, (o) => o.currency) : this.$store.state.auth.currencies

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      getExpanded (data) {
        for (let row of data) {
          if (row._showChildren) {
            this.expandedMap[row.entity_id] = row._showChildren
            if (row._children) {
              this.getExpanded(row._children)
            }
          }
        }
      }

    }

  }
</script>
